<template>
    <div>
        <common-table :table-columns="tableColumns" :url="url" :operate="[]" :form-fields="formFields" :permission="permission" :searchs="[]" ref="table"></common-table>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "UserGroup",
        components: {CommonTable},
        data() {
            return {
                permission:{
                    add: 'userGroup:add',
                    update: 'userGroup:update',
                    delete: 'userGroup:delete',
                    deleteBatch: 'userGroup:deleteBatch'
                },
                url: {
                    get: '/userGroup/listByCondition',
                    add: '/userGroup/add',
                    update: '/userGroup/update',
                    delete: '/userGroup/delete',
                    delete_batch: '/userGroup/deleteBatch',
                    status: '/userGroup/status'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                }, {
                    field: 'name',
                    label: '分组名称',
                    show: true,
                }, {
                    field: 'templateId',
                    label: '模板名称',
                    selectUrl: '/userTemplate/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'content',
                    label: '模板内容',
                    show: true,
                    lineFeed: true,
                    center: false,
                }],
                formFields: {
                    addTitle: '添加分组',
                    updateTitle: '修改分组',
                    labelWidth: '105px',
                    model: [{
                        field: 'name',
                        label: '分组名称：',
                        type: 'input',
                        placeholder: '分组名称',
                        rules:[{
                            message: '请输入分组名称', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'templateId',
                        label: '选择模板：',
                        type: 'select',
                        selectUrl: '/userTemplate/getAll',
                        selectData: [],
                        placeholder: '选择模板',
                        rules:[{
                            message: '请选择模板', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
